<template>
  <div class="banner-container">
    <el-carousel
      :interval="5000"
      arrow="always"
      height="300px"
      indicator-position
    >
      <el-carousel-item v-for="(banner, index) in banners" :key="index">
        <a
          href="javascript:void(0);"
          rel="noopener noreferrer"
          class="img-wrap"
        >
          <img :src="banner.img" alt />
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  props: {
    banners: {
      type: Array,
      default: function() {
        return []
      }
    }
  }
}
</script>

<style lang="scss">
.banner-container {
}
</style>
